import { render } from "./CampaignJourneyLayout.vue?vue&type=template&id=6aa6bc7b&scoped=true"
import script from "./CampaignJourneyLayout.vue?vue&type=script&lang=js"
export * from "./CampaignJourneyLayout.vue?vue&type=script&lang=js"

import "./CampaignJourneyLayout.vue?vue&type=style&index=0&id=6aa6bc7b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa6bc7b"]])

export default __exports__